module.exports = __webpack_public_path__ + "static/media/entryBackground.5a7de40b.png";